export function targetedNoticesSlider() {
    const $sliderInfo = $('.targeted-notices-info-slider');
    const $sliderNav = $('.targeted-notices-nav-slider');
    const $sliderNavHolder = $('.targeted-notices-nav-arrows');
    const $sliderNavPrev = $sliderNavHolder.find('.prev');
    const $sliderNavNext = $sliderNavHolder.find('.next');
    const sliderLength = $sliderInfo.find(".item").length;
    console.log(sliderLength);
    console.log(sliderLength > 1);
    if (sliderLength > 1) {
        $sliderNavHolder.addClass("show");
    } else {
        $sliderNavHolder.removeClass("show");
    }
    $sliderInfo.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: $sliderNav
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (nextSlide === 0) {
            $sliderNavPrev.attr('aria-hidden', 'true').attr('tabindex', '-1').addClass('disabled');
        } else {
            $sliderNavPrev.removeAttr('aria-hidden tabindex').removeClass('disabled');
        }
        if (nextSlide >= (sliderLength - 1)) {
            $sliderNavNext.attr('aria-hidden', 'true').attr('tabindex', '-1').addClass('disabled');
        } else {
            $sliderNavNext.removeAttr('aria-hidden tabindex').removeClass('disabled');
        }
    });
    $sliderNav.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: $sliderInfo,
        infinite: false,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        variableWidth: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 7,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                }
            },
        ]
    });
    $sliderNavPrev.on("click", function () {
        $sliderInfo.slick('slickPrev');
        // $sliderNav.slick('slickPrev');
    });

    $sliderNavNext.on("click", function () {
        $sliderInfo.slick('slickNext');
        // $sliderNav.slick('slickNext');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/targeted-notices-slider.js